import Form from 'components/earning-codes/EarningCodeForm';
import React from 'react';
import 'containers/earning-codes/earning-code.scss';
const EditEarningCodes = () => {
  return <Form />;
};

export default EditEarningCodes;
